import * as types from './types';

const initialState = {
  postingContactData: {},
  hasPostingContactData: false,
  loadingPostingContactData: false,
  errorGetPostingContactData: false,
  updatedUserResponsible: false,
  updatingUserResponsible: false,
  errorUpdatingUserResponsible: false
};

function contactDataInfoReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_POSTING_CONTACT_DATA:
      return {
        ...state,
        loadingPostingContactData: true,
        updatedUserResponsible: false
      };
    case types.GET_POSTING_CONTACT_DATA_COMPLETED:
      return {
        ...state,
        postingContactData: action.payload,
        hasPostingContactData: true,
        loadingPostingContactData: false,
        errorGetPostingContactData: false
      };
    case types.GET_POSTING_CONTACT_DATA_FAILED:
      return {
        ...state,
        hasPostingContactData: false,
        loadingPostingContactData: false,
        errorGetPostingContactData: true
      };

    case types.UPDATE_USER_RESPONSIBLE_FOR_POSTING:
      return {
        ...state,
        updatedUserResponsible: false,
        updatingUserResponsible: true
      };
    case types.UPDATE_USER_RESPONSIBLE_FOR_POSTING_COMPLETED:
      return {
        ...state,
        updatedUserResponsible: true,
        updatingUserResponsible: false,
        errorUpdatingUserResponsible: false
      };
    case types.UPDATE_USER_RESPONSIBLE_FOR_POSTING_FAILED:
      return {
        ...state,
        updatedUserResponsible: false,
        updatingUserResponsible: false,
        errorUpdatingUserResponsible: true
      };

    default:
      return state;
  }
}

export { contactDataInfoReducer };
